import { render } from "./AppHeadline.vue?vue&type=template&id=43ce2e16&scoped=true"
const script = {}

import "./AppHeadline.vue?vue&type=style&index=0&id=43ce2e16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ce2e16"]])

export default __exports__